import React from 'react';
import { Typography, Container, Box, Card, Grid, CardMedia } from '@mui/material';
import { styled } from '@mui/material/styles';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import store1 from '../assets/store/store1.jpg';
import store2 from '../assets/store/store2.jpg';
import store3 from '../assets/store/store3.jpg';
import { useLanguage } from '../LanguageContext';
import { translations } from '../translations';

// keyframes removed because not used

const StoreCard = styled(Card)(({ theme }) => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    borderRadius: theme.spacing(2),
    overflow: 'hidden',
    '&:hover': {
        transform: 'translateY(-12px) scale(1.02)',
        boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
    }
}));

const ContactUsView = () => {
    const { language } = useLanguage();
    const t = translations[language].contact;

    return (
        <Box sx={{ pt: 4, pb: 8, px: 2 }}>
            {/* Stores Section */}
            <Container maxWidth="lg" sx={{ mb: 10, px: { xs: 0, sm: 2 } }}>
                <Typography 
                    variant="h3" 
                    component="h2" 
                    gutterBottom
                    sx={{ 
                        fontWeight: 700,
                        mb: 3,
                        fontSize: { xs: '2rem', md: '2.75rem' }
                    }}
                >
                    {t.storesTitle}
                </Typography>
                
                <Typography 
                    variant="body1" 
                    sx={{ 
                        mb: 3,
                        fontSize: { xs: '1rem', md: '1.1rem' },
                        color: 'text.secondary',
                        lineHeight: 1.8,
                        textAlign: 'left'
                    }}
                >
                    {t.storesDescription}
                </Typography>

                <Box sx={{ mb: 6, pl: { xs: 2, md: 3 } }}>
                    {t.stores.map((store, index) => (
                        <Typography 
                            key={index}
                            variant="body1" 
                            sx={{ 
                                mb: 1.5,
                                fontSize: { xs: '1rem', md: '1.1rem' },
                                lineHeight: 1.8,
                                textAlign: 'left'
                            }}
                        >
                            • <Typography 
                                component="a"
                                href={store.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    color: 'primary.main',
                                    textDecoration: 'none',
                                    fontWeight: 500,
                                    '&:hover': {
                                        textDecoration: 'underline',
                                    }
                                }}
                            >
                                {store.name}
                            </Typography>
                        </Typography>
                    ))}
                </Box>
                
                <Grid container spacing={3}>
                    <Grid size={{xs:12, sm:6, md:4}}>
                        <StoreCard>
                            <CardMedia
                                component="img"
                                image={store1}
                                alt="Ski Retailer Store 1"
                                sx={{ 
                                    height: { xs: 200, md: 250 },
                                    objectFit: 'cover'
                                }}
                            />
                        </StoreCard>
                    </Grid>
                    <Grid size={{xs:12, sm:6, md:4}}>
                        <StoreCard>
                            <CardMedia
                                component="img"
                                image={store2}
                                alt="Ski Retailer Store 2"
                                sx={{ 
                                    height: { xs: 200, md: 250 },
                                    objectFit: 'cover'
                                }}
                            />
                        </StoreCard>
                    </Grid>
                    <Grid size={{xs:12, sm:6, md:4}}>
                        <StoreCard>
                            <CardMedia
                                component="img"
                                image={store3}
                                alt="Ski Retailer Store 3"
                                sx={{ 
                                    height: { xs: 200, md: 250 },
                                    objectFit: 'cover'
                                }}
                            />
                        </StoreCard>
                    </Grid>
                </Grid>
            </Container>

            {/* Header Section */}
            <Container maxWidth="lg" sx={{ mb: 10, px: { xs: 0, sm: 2 } }}>                <Typography 
                    variant="h3" 
                    component="h1" 
                    gutterBottom
                    sx={{ 
                        fontWeight: 700,
                        mb: 3,
                        fontSize: { xs: '2rem', md: '2.75rem' },
                        textAlign: 'center'
                    }}
                >
                    {t.title}
                </Typography>
                <Typography 
                    variant="body1" 
                    sx={{ 
                        fontSize: '1.1rem',
                        color: 'text.secondary',
                        mb: 3,
                        lineHeight: 1.8,
                        textAlign: 'left'
                    }}
                >
                    {t.description}
                </Typography>
                
                {/* Contact Information */}
                <Box sx={{ mt: 4 }}>
                    {/* Email */}
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <EmailIcon sx={{ color: 'primary.main', mr: 2, fontSize: 28 }} />
                        <Typography 
                            component="a" 
                            href={`mailto:${t.emailAddress}`}
                            variant="h6"
                            sx={{ 
                                color: 'primary.main',
                                textDecoration: 'none',
                                fontWeight: 600,
                                '&:hover': {
                                    textDecoration: 'underline',
                                }
                            }}
                        >
                            {t.emailAddress}
                        </Typography>
                    </Box>

                    {/* Facebook */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <FacebookIcon sx={{ color: '#1877F2', mr: 2, fontSize: 28 }} />
                        <Typography 
                            component="a" 
                            href="https://www.facebook.com/profile.php?id=61570656624039"
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="h6"
                            sx={{ 
                                color: '#1877F2',
                                textDecoration: 'none',
                                fontWeight: 600,
                                '&:hover': {
                                    textDecoration: 'underline',
                                }
                            }}
                        >
                            Facebook
                        </Typography>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default ContactUsView;


